/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface SiegeSocialChefEntrepriseSearchDto
 */
export interface SiegeSocialChefEntrepriseSearchDto {
    /**
     * 
     * @type {TextSearch}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    prenom?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    dateNaissance?: DateSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    fonction?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    chefEntreprisePrincipal?: BooleanSearch;
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialChefEntrepriseSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SiegeSocialChefEntrepriseSearchDto interface.
 */
export function instanceOfSiegeSocialChefEntrepriseSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeSocialChefEntrepriseSearchDtoFromJSON(json: any): SiegeSocialChefEntrepriseSearchDto {
    return SiegeSocialChefEntrepriseSearchDtoFromJSONTyped(json, false);
}

export function SiegeSocialChefEntrepriseSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeSocialChefEntrepriseSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : TextSearchFromJSON(json['prenom']),
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : DateSearchFromJSON(json['dateNaissance']),
        'fonction': !exists(json, 'fonction') ? undefined : TextSearchFromJSON(json['fonction']),
        'chefEntreprisePrincipal': !exists(json, 'chefEntreprisePrincipal') ? undefined : BooleanSearchFromJSON(json['chefEntreprisePrincipal']),
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SiegeSocialChefEntrepriseSearchDtoToJSON(value?: SiegeSocialChefEntrepriseSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'prenom': TextSearchToJSON(value.prenom),
        'dateNaissance': DateSearchToJSON(value.dateNaissance),
        'fonction': TextSearchToJSON(value.fonction),
        'chefEntreprisePrincipal': BooleanSearchToJSON(value.chefEntreprisePrincipal),
        'idsiegeSocial': value.idsiegeSocial,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

